import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/kodiaq/media",
  "description": "Для обновленного ŠKODA KODIAQ 2023 предлагаются три информационно-развлекательные системы с цветными дисплеями диагональю от 8 дюймов. Внедорожник оснащен системой ЭРА-ГЛОНАСС. Подробный обзор автомобиля, фото, технические характеристики, комплектации  на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Kodiaq Media",
  "name": "kodiaq-media",
  "title": "Медиасистемы обновленного ŠKODA KODIAQ 2023/2022 | Штатная магнитола и информационно-развлекательные системы Шкода Кодиак - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageSubHeading = makeShortcode("SimpleMainStageSubHeading");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedGallery = makeShortcode("QueriedGallery");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="left" horizontalAlign="left" src="/m/kodiaq-2021-media-banner.jpg" mobileSrc="/m/kodiaq-2021-media-banner-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageSubHeading mdxType="SimpleMainStageSubHeading">ŠKODA</SimpleMainStageSubHeading>
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">Всегда на связи</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    В каждом ŠKODA KODIAQ вы найдёте информационно-развлекательную систему с
    цветным сенсорным экраном диагональю от 6,5 до 10 дюймов. Минимальный
    функционал — радио, проигрывание аудиозаписей с USB-носителей, разговоры по
    телефону в режиме громкой связи, управление посредством клавиш на рулевом
    колесе. У старших систем есть такие функции, как просмотр видео, штатная
    навигация, стабильно работающая в самых сложных условиях и без выхода в
    интернет, управление с помощью голоса и жестов — например, чтобы включить
    нужную радиостанцию, достаточно просто назвать её.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="kodiaq-fl-media-slider-one" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/kodiaq-2021-media-banner-2.jpg" mobilePic="/m/kodiaq-2021-media-banner-2-mob.jpg" model="kodiaq" alignRight mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle"> SMARTLINK </ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" alignRight mdxType="ShowRoomTextBlockText">
    После установления соединения (по кабелю или «по воздуху», SmartLink
    поддерживает беспроводное подключение с телефонами Apple) вы сможете
    отобразить на центральном дисплее машины онлайн-карту для прокладки маршрута
    с учётом текущих пробок (например, вывести «Яндекс.Навигатор»), включить
    одну из тысяч станций интернет-радио, прослушать или надиктовать сообщение в
    мессенджеры
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> Умные технологии </DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="kodiaq-fl-mediapage" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FAFAFA" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      